<template>
  <div class="laboratory ma-0 mb-5">
    <div v-if="$i18n.locale=='tc'" class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full_chi }}</div>
    <div v-else class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full }}</div>
    <v-alert v-if="equipmentLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">        
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==false && equipmentLock==false && $cookies.get('role')=='overrider'" border="left" color="red lighten-1" dark>
      <div>
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_enter_overrider") }}
      </div>
    </v-alert>
      <div v-if="loaded">
          <div v-if="name == 'apparent_depth'">
            <ApparentDepth @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride"/>
          </div>
          <div v-if="name == 'centripetal_force'">
            <CentripetalForce @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'em_induction'">
            <EmInduction @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'emission_spectrum'">
            <EmissionSpectrum @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'interference'">
            <Interference @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>          
          <div v-if="name == 'interference_diffraction'">
            <InterferenceDiffraction @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'pendulum'">
            <Pendulum @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'photoelectric'">
            <Photoelectric @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'greenhouse'">
            <Greenhouse @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'complex_formation'">
            <ComplexFormation @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'titration'">
            <Titration @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'redox'">
            <Redox @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'visible_spectrum'">
            <VisibleSpectrum @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'air_monitoring'">
            <AirMonitoring @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'environmental_monitoring'">
            <EnvironmentalMonitoring @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'iodine_test'">
            <IodineTest @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'photosynthesis'">
            <Photosynthesis @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'respiration'">
            <Respiration @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'vitamin_c'">
            <VitaminC @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
      </div>
    <v-overlay absolute :value="initialize">
              <v-progress-circular
      :size="50"
      :width="5"
      color="green accent-2"
      indeterminate
    ></v-progress-circular>
          </v-overlay>
  </div>
</template>
<script>
import ExperimentBasic from "@/services/dds/api_basic_experiment";

import ApparentDepth from "@/components/experiment/ApparentDepth.vue";
import CentripetalForce from "@/components/experiment/CentripetalForce.vue";
import ComplexFormation from "@/components/experiment/ComplexFormation.vue";
import EmInduction from "@/components/experiment/EmInduction.vue";
import EmissionSpectrum from "@/components/experiment/EmissionSpectrum.vue";
import EnvironmentalMonitoring from "@/components/experiment/EnvironmentalMonitoring.vue";
import Interference from "@/components/experiment/Interference.vue";
import InterferenceDiffraction from "@/components/experiment/InterferenceDiffraction.vue";
import IodineTest from "@/components/experiment/IodineTest.vue";
import Pendulum from "@/components/experiment/Pendulum.vue";
import Photoelectric from "@/components/experiment/Photoelectric.vue";
import Photosynthesis from "@/components/experiment/Photosynthesis.vue";
import Redox from "@/components/experiment/Redox.vue";
import Respiration from "@/components/experiment/Respiration.vue";
import Titration from "@/components/experiment/Titration.vue";
import VitaminC from "@/components/experiment/VitaminC.vue";


import {api_dds_booking} from '@/services/dds/api_dds_booking';
const apiDDSBooking = new api_dds_booking(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
    ApparentDepth,
    CentripetalForce,
    ComplexFormation,
    EmInduction,
    EmissionSpectrum,
    EnvironmentalMonitoring,
    Interference,
    InterferenceDiffraction,
    IodineTest,
    Pendulum,
    Photoelectric,
    Photosynthesis,
    Redox,
    Respiration,
    Titration,
    VitaminC,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      name: "",
      override: 0,
      equipmentLock: false,
      bookingLock:false,
      bookingOverride: false,
      checkEnd: true,
      inte: null,
      role: null,
      drawer: true,
      initialize: true,
      loaded: false,
      mini: true,
      school_code: "",      
      current:{
        school_code: null,
        username: null,
        uid: null,
        user_level: "STUDENT",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api:{
        school_code: null,
        school_enname: null,
        school_chname: null,
        experiment: null,
        equipment_id: null,
        room_id: null,
        school_logo: null,
        experiment_name: null,
        experiment_set_full: null,
        experiment_set_full_chi: null,
      },
      title:{
        interference: 'INTERFERENCE',
      },
      room: {
        set_1: 'Room 1',
        set_2: 'Room 2',
        set_3: 'Room 3',
        set_4: 'Room 4',
        set_5: 'Room 1',
        set_1: 'Room 1',
      }
    };
  },
  mounted: function () {
    var self = this;
    self.name = self.$route.params.experiment;
    self.school_code = self.$route.params.school_code;
    self.experiment = self.$route.params.experiment;
    self.equipment_id = self.$route.params.equipment_id;
    self.$store.state.current.school_code = self.school_code;
    self.$store.state.current.experiment = self.experiment;
    self.$store.state.current.equipment_id = self.equipment_id;
    
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;

        
    setTimeout(function(){
      if(self.$route.name == 'experiment'){
      }
      else {
      }
      self.initialization();
    },1000);
  },
  methods: {
    initialization(){
      var self = this;
      apiDDSBooking.getSchoolInfo(self.school_code)
        .then((response) => {
          if(response.status=='success') {
            self.api.school_code = response.school_code;
            self.api.school_enname = response.school_enname;
            self.api.school_chname = response.school_chname;
            apiDDSBooking.getSchoolExperimentSetInfo(self.school_code, self.experiment, self.equipment_id)
              .then((response) => {
                if(response.status=='success') {
                  self.api.experiment = self.experiment;
                  self.api.equipment_id = self.equipment_id;
                  apiDDSBooking.getEquipmentAndBookingStatus(self.$cookies.get("booking_id"),self.school_code, self.experiment, self.equipment_id)
                    .then((response) => {
                      if(response.eStatus=="EXPIRED" && self.current.user_level !="ADMIN"){
                        self.initialize = false;
                        if(self.$i18n.locale == 'tc'){
                          alert("Equipment usage right expired, force leaving is triggered...");
                        }
                        else {
                          alert("設備使用權限已過期，正在強制離開頁面﹒﹒﹒");
                        }
                      }
                      if(response.eStatus=="HOLD" || response.eStatus=="EXPIRED"){
                        self.equipmentLock = true;
                      }
                      if(response.bStatus=="SUSPENDED" || response.bStatus=="UNAVAILABLE" || response.bStatus=="MAINTENANCE"){
                        self.bookingLock = true;
                      }
                      self.api.room_id = self.setRoomTranslate(self.api.equipment_id);
                      self.loaded = true;
                      self.initialize = false;
                      self.api.experiment_set_full = response.experiment_set_full;
                      self.api.experiment_set_full_chi = response.experiment_set_full_chi;
                      if(self.equipmentLock == true && self.$cookies.get("role")=="overrider") {
                        //self.checkBookingEnd();
                      }
                      else self.checkBookingEnd();
                      self.inte = setInterval(function() {
                        if( self.equipmentLock == true && self.$cookies.get("role")=="overrider" ) {
                          // no action
                        }
                        else {
                          self.checkBookingEnd();
                        }
                      }, 10000);                      
                    });
                }
                else {
                  self.initialize = false;
                  alert(response.error);
                }
              });
          }
          else {
            self.initialize = false;
            alert(response.error);
          }
        });
    },
    setRoomTranslate(equipment_id){
      let num = equipment_id.split('set_').pop();
      return "Room "+num;
    },
    changeCheckBookingEnd(){
      var self = this;
      self.checkEnd = !self.checkEnd;
    },
    changeOverride(override){
      var self = this;
      if (override.bStatus == "SUSPENDED")
        self.bookingLock = true;
      else 
        self.bookingLock = false;
      if (override.eStatus == "HOLD")
        self.equipmentLock = true;
      else 
        self.equipmentLock = false;
    },    
  },
  destroyed(){
    var self = this;
    clearInterval(self.inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    self.$cookies.remove("end_at");
    self.$cookies.remove("booking_id");
    self.$cookies.remove("session_token");
    self.$store.state.current.booking_id = null;
    self.$store.state.current.end_at = null;
    self.$store.state.current.school_code = null;
    self.$store.state.current.experiment = null;
    self.$store.state.current.equipment_id = null;
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>